import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../../../../application/language/useI18n';

export interface IListItemLinkProperties {
  itemKey?: string;
  url: string;
  primaryText: string;
  secondaryText?: string;
  icon?: any;
  color?: ListItemLinkColor;
  containerClassName?: string;
  primaryTextClassName?: string;
  secondaryTextClassName?: string;
  isSelected?: boolean;
  onClick?: () => void;
}

export enum ListItemLinkColor {
  default = 'default',
  light = 'light',
  danger = 'danger',
}

export const ListItemLink = ({
  color = ListItemLinkColor.default,
  itemKey,
  url,
  primaryText,
  secondaryText,
  icon = null,
  containerClassName = '',
  primaryTextClassName = '',
  secondaryTextClassName = '',
  isSelected,
  onClick = () => {},
}: IListItemLinkProperties) => {
  const i18 = useI18n()
  const colorToStyleMap: any = {
    [ListItemLinkColor.default]: {},
    [ListItemLinkColor.light]: { color: '#b3e5fc' },
    [ListItemLinkColor.danger]: { color: '#ff8a65' },
  };
  const classes = useStyles();

  let linkTextStyle = colorToStyleMap[color] || colorToStyleMap[ListItemLinkColor.default];
  return (
    <ListItem
      className={isSelected ? classes.selected : containerClassName}
      style={linkTextStyle}
      key={itemKey}
      button
      component={Link}
      to={url}
      onClick={onClick}
    >
      {icon && <ListItemIcon children={icon} />}
      <ListItemText
        primaryTypographyProps={{ className: primaryTextClassName }}
        secondaryTypographyProps={{ className: secondaryTextClassName }}
        primary={i18.translate(primaryText)}
        secondary={secondaryText}
      />
    </ListItem>
  );
};

const useStyles = makeStyles(() => ({
  selected: {
    backgroundColor: '#90CAF929',
  },
}));
